import { render, staticRenderFns } from "./NewTemplateMenu.vue?vue&type=template&id=e99816a8"
import script from "./NewTemplateMenu.vue?vue&type=script&lang=js"
export * from "./NewTemplateMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports